// extracted by mini-css-extract-plugin
export default {"tooltip":"TM-z","arrow":"UM-z"};